import React from 'react';
import { Routes, Route, Link, Navigate } from 'react-router-dom';
import BookingMaintenance from './BookingMaintenance';
import BookingOther from './BookingOther';
import './booking.scss'; // 確保有樣式
import Error404 from '../../pages/errorPages/Error404';

const BookingRoutes = () => {
  return (
    <Routes>
      {/* 預設首頁，提供選擇 */}
      {/* <Route
        path="/"
        element={
          <div className="booking-home">
            <h2>請選擇預約類型</h2>
            <div className="button-group">
              <Link to="/lexus/booking/maintenance" className="booking-button">
                預約保養
              </Link>
              <Link to="/lexus/booking/other" className="booking-button">
                預約其他
              </Link>
            </div>
          </div>
        }
      /> */}

      {/* 進入預約表單 */}
      <Route path="maintenance" element={<BookingMaintenance />} />
      <Route path="other" element={<BookingOther />} />

      {/* 其他路徑跳轉回 `/booking/` */}
      {/* <Route path="*" element={<Navigate to="/booking/" />} /> */}
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};

export default BookingRoutes;
